export const fetchPrivacy = (resp) => ({
  type: 'FETCH_PRIVACY',
  payload: resp,
});

export default {
  fetchPrivacy,
};
